// src/utils/browserTabBadge.js
let originalTitle = null;
let originalFaviconHref = null;
let faviconBadged = false;
let applyGen = 0;

const sources = {
  mentions: false,
  pendingCount: 0,
};

const getFaviconLink = () => {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  return link;
};

const captureBaseTitle = () => {
  if (originalTitle != null) return originalTitle;
  originalTitle = String(document.title || "")
    .replace(/^●\s*/, "")
    .replace(/^\(\d+\)\s*/, "");
  return originalTitle;
};

const drawFaviconWithDot = (baseHref) => {
  return new Promise((resolve) => {
    const size = 32;
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      resolve(baseHref);
      return;
    }

    const finish = () => {
      ctx.beginPath();
      ctx.arc(size - 8, size - 8, 7, 0, Math.PI * 2);
      ctx.fillStyle = "#e53935";
      ctx.fill();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#fff";
      ctx.stroke();
      resolve(canvas.toDataURL("image/png"));
    };

    if (!baseHref) {
      ctx.fillStyle = "#1976d2";
      ctx.fillRect(0, 0, size, size);
      finish();
      return;
    }

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      ctx.drawImage(img, 0, 0, size, size);
      finish();
    };
    img.onerror = () => {
      ctx.fillStyle = "#1976d2";
      ctx.fillRect(0, 0, size, size);
      finish();
    };
    img.src = baseHref;
  });
};

const applyAppIconBadge = async (count) => {
  if (typeof navigator === "undefined") return;
  try {
    if (count > 0 && typeof navigator.setAppBadge === "function") {
      await navigator.setAppBadge(count);
    } else if (typeof navigator.clearAppBadge === "function") {
      await navigator.clearAppBadge();
    }
  } catch {
    // Badging API no disponible (Safari, Firefox, pestaña normal, etc.)
  }
};

const applyTabAttention = async () => {
  if (typeof document === "undefined") return;
  const gen = ++applyGen;
  const mention = !!sources.mentions;
  const pending = Math.max(0, Number(sources.pendingCount) || 0);
  const active = mention || pending > 0;
  const base = captureBaseTitle();

  if (mention && pending > 0) {
    document.title = `● (${pending}) ${base}`;
  } else if (mention) {
    document.title = `● ${base}`;
  } else if (pending > 0) {
    document.title = `(${pending}) ${base}`;
  } else {
    document.title = base;
  }

  const appCount = pending > 0 ? pending : mention ? 1 : 0;
  await applyAppIconBadge(appCount);
  if (gen !== applyGen) return;

  const link = getFaviconLink();
  if (active) {
    if (faviconBadged) return;
    if (originalFaviconHref == null) {
      originalFaviconHref = link.href || "";
    }
    const badged = await drawFaviconWithDot(originalFaviconHref || link.href);
    if (gen !== applyGen) return;
    link.href = badged;
    faviconBadged = true;
    return;
  }

  if (!faviconBadged) return;
  if (originalFaviconHref != null) {
    link.href = originalFaviconHref;
  }
  originalFaviconHref = null;
  faviconBadged = false;
};

/** Punto rojo + título (menciones de chat / notas). Compatible con el recuento de horario. */
export const setBrowserTabBadge = async (active) => {
  sources.mentions = !!active;
  await applyTabAttention();
};

/** Recuento de solicitudes pendientes: título `(n)`, favicon y badge de app instalada. */
export const setPendingRequestsTabBadge = async (count) => {
  sources.pendingCount = Math.max(0, Number(count) || 0);
  await applyTabAttention();
};

export const isBrowserTabBadgeActive = () =>
  !!sources.mentions || sources.pendingCount > 0;
